module.exports = __webpack_public_path__ + "static/media/upload-format.4641ab7e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/upload-format.svg
// module id = 1705
// module chunks = 17